export function validateBundleInfo({ mismatch, mfeHasCompatibleLaunchDarklyVersion }, { exposedDependencies = {}, exposedInstanceDependencies, logService, packageUrl }) {
    var _a, _b;
    if (!logService) {
        return;
    }
    if (mismatch) {
        const data = { package: packageUrl, dependencies: JSON.stringify(mismatch) };
        if (Object.keys(exposedDependencies).length === 0) {
            logService.warning({
                category: 'MicroFrontends.NoExposedDependencies',
                message: 'Cannot use light bundle because the host is not exposing dependencies or the list of shared dependencies is empty.',
                data,
            });
        }
        else {
            logService.warning({
                category: 'MicroFrontends.DependenciesMismatch',
                message: 'Some of the package dependencies have incompatible versions.',
                data,
            });
        }
    }
    /**
     * Note, only checking false here because the value is undefined when the host
     * or the MFE isn't using LaunchDarkly at all.
     */
    if (mfeHasCompatibleLaunchDarklyVersion === false) {
        const data = {
            package: packageUrl,
            hostVersion: (_b = (_a = exposedInstanceDependencies === null || exposedInstanceDependencies === void 0 ? void 0 : exposedInstanceDependencies.launchDarkly) === null || _a === void 0 ? void 0 : _a.version) !== null && _b !== void 0 ? _b : '',
        };
        logService.warning({
            category: 'MicroFrontends.LaunchDarklyMismatch',
            message: 'LaunchDarkly versions are incompatible',
            data,
        });
    }
}
//# sourceMappingURL=validate-bundle-info.js.map